module.exports = __webpack_public_path__ + "media/themes-and-styles.f38982d6952804a5196400c532f63852.svg";